import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ColorProp } from '@lib/types';
import { StyleObj } from '@providers/Theme/types';
import { Icon, IconProps } from '@components/Icon';
import { Typography, TypographyProps } from '@components/Typography';
import { makeStyles, useTheme } from '@providers/Theme';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  startIcon: {
    marginRight: theme.spacing(0.5),
  },
  endNode: {
    marginLeft: theme.spacing(1),
  },
}));

type OrderDetailsRowProps = {
  StartIconProps?: IconProps;
  EndIconProps?: IconProps;
  endNode?: React.ReactNode;
  TypographyProps?: Partial<TypographyProps>;
  text: React.ReactNode;
  color?: ColorProp;
  style?: StyleObj;
};

export const OrderDetailsRow: React.FC<OrderDetailsRowProps> = ({
  StartIconProps,
  EndIconProps,
  TypographyProps: TypographyPropsOverride,
  text,
  color: colorFromProps,
  endNode,
  style,
}) => {
  const theme = useTheme();
  const color =
    typeof colorFromProps === 'function'
      ? colorFromProps(theme)
      : colorFromProps ?? theme.palette.grey[700];
  const styles = useStyles();

  return (
    <View style={styles.root}>
      {StartIconProps && (
        <Icon
          color={color}
          size={14}
          {...StartIconProps}
          style={{
            ...styles.startIcon,
            ...StyleSheet.flatten(StartIconProps?.style),
          }}
        />
      )}
      <Typography
        size="sm"
        weight="light"
        {...TypographyPropsOverride}
        style={{
          color,
          ...StyleSheet.flatten(TypographyPropsOverride?.style),
          ...style,
        }}>
        {text}
      </Typography>
      {EndIconProps && (
        <Icon
          color={color}
          size={14}
          {...EndIconProps}
          style={{
            ...styles.endNode,
            ...StyleSheet.flatten(EndIconProps?.style),
          }}
        />
      )}
      {endNode && <View style={styles.endNode}>{endNode}</View>}
    </View>
  );
};
